export interface CanvaTemplate {
  id: string;
  title: string;
  category: 'wedding' | 'birthday' | 'corporate' | 'holiday' | 'other';
  previewImage: string;
  canvaUrl: string;
}
export const CANVA_TEMPLATES: CanvaTemplate[] = [

  // Wedding Invitations — QR Code Templates ✅
  {
    id: 'wedding-1',
    title: 'Wedding QR Code Sign (Blue & White)',
    category: 'wedding',
    previewImage: 'assets/canva-templates/wedding-1.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAHHBsDJquE-white-and-blue-minimalist-elegant-wedding-qr-code-sign-document/'
  },
  {
    id: 'wedding-2',
    title: 'Wedding RSVP QR Code Invitation (Green)',
    category: 'wedding',
    previewImage: 'assets/canva-templates/wedding-2.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAHK9OfaNqw-white-and-green-minimalist-wedding-rsvp-qr-code-invitation/'
  },
  {
    id: 'wedding-3',
    title: 'Wedding RSVP QR Code Invitation (Floral)',
    category: 'wedding',
    previewImage: 'assets/canva-templates/wedding-3.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAHK9KWVZz0-white-blue-floral-minimalist-wedding-rsvp-qr-code-invitation/'
  },
  {
    id: 'wedding-4',
    title: 'Wedding Invitation (Pale Orange & Yellow)',
    category: 'wedding',
    previewImage: 'assets/canva-templates/wedding-4.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAFSoBzVFug-very-pale-orange-and-light-grayish-yellow-minimalist-flower-wedding-invitation/'
  },
 
  {
    id: 'wedding-6',
    title: 'Wedding RSVP QR Code Invitation (Black Floral)',
    category: 'wedding',
    previewImage: 'assets/canva-templates/wedding-6.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAGVEX2km1g-black-floral-patterned-wedding-rsvp-invitation/'
  },


  // Birthday Invitations — QR Code Templates ✅
  // NOTE: Canva has only 1 free birthday-branded QR code template.
  // Slots 1 & 2 are the two published variants of that template.
  // Slots 3–6 are free birthday invitation templates from QR code search results.
  {
    id: 'birthday-1',
    title: 'Birthday Party Invitation with QR (Lilac)',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-1.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAF-s7QzZs0-birthday-party-invitation-in-lilac-purple-black-delicate-elegance-style/'
  },
  {
    id: 'birthday-2',
    title: 'Birthday Party Invitation Pink & Beige',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-2.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAF5_XYRPPE-beige-and-pink-birthday-party-invitation/'
  },
  {
    id: 'birthday-3',
    title: 'Blue Watercolor Birthday',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-3.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAF6StAMOec-blue-watercolor-birthday-party-invitation-portrait/'
  },
  {
    id: 'birthday-4',
    title: 'Elegant Birthday Soirée',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-4.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAGuCzWsmPQ-black-and-gold-elegant-birthday-party-flyer-a4-/'
  },
  {
    id: 'birthday-5',
    title: 'Fun Kids Birthday',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-5.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAFUEza2_W0-colorful-fun-and-playful-illustrated-kids-birthday-invitation/'
  },
  {
    id: 'birthday-6',
    title: 'Neon Party Night',
    category: 'birthday',
    previewImage: 'assets/canva-templates/birthday-6.jpg',
    canvaUrl: 'https://www.canva.com/templates/EAG0vrE3Uo8-pink-and-black-modern-birthday-party-invitation/'
  },


  // // Corporate Invitations ✅ COMPLETE
  // ... (unchanged, kept commented out as in original)

  // // Holiday Invitations ✅ COMPLETE
  // ... (unchanged, kept commented out as in original)


  // ── Synced from Canva folder (baked in 2026-07-08) ──────────────────────────
  // Previously fetched live from the S3/Canva API on every template-page open.
  // Folded into this static list so we no longer call the API (see
  // canva-template.service.ts). Thumbnails live in assets/canva-templates/ as
  // canva-<designId>.jpg. Re-run the sync + re-export thumbnails to refresh.
  {
    id: 'DAHFDTzAq4k',
    title: 'Table Top Flyer - Forest',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-forest.jpg',
    canvaUrl: 'https://www.canva.com/design/DAHFDTzAq4k/view'
  },
  {
    id: 'DAHFDQOG5WY',
    title: 'Table Top Flyer - Seasons',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-seasons.jpg',
    canvaUrl: 'https://www.canva.com/design/DAHFDQOG5WY/view'
  },
  {
    id: 'DAG-SgfLnPQ',
    title: 'Table Top Flyer - Red Traditional Indian',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-red-traditional.jpg',
    canvaUrl: 'https://www.canva.com/design/DAG-SgfLnPQ/view'
  },
  {
    id: 'DAG-So_V5-Y',
    title: 'Table Top Flyer - Beige Minimalistic',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-beige.jpg',
    canvaUrl: 'https://www.canva.com/design/DAG-So_V5-Y/view'
  },
  {
    id: 'DAG-SDsm2j8',
    title: 'Table Top Flyer- Cream Minimal',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-cream.jpg',
    canvaUrl: 'https://www.canva.com/design/DAG-SDsm2j8/view'
  },
  {
    id: 'DAG-SBnY3dw',
    title: 'Table Top Flyer - Pink',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-pink.jpg',
    canvaUrl: 'https://www.canva.com/design/DAG-SBnY3dw/view'
  },
  {
    id: 'DAHE8Hknh2c',
    title: 'Table Top Flyer - Fun Peach Flower',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-peach.jpg',
    canvaUrl: 'https://www.canva.com/design/DAHE8Hknh2c/view'
  },
  {
    id: 'DAG-SGor8SU',
    title: 'Table Top Flyer - Gold and White Traditional Indian',
    category: 'other',
    previewImage: 'assets/canva-templates/picaggo-gold.jpg',
    canvaUrl: 'https://www.canva.com/design/DAG-SGor8SU/view'
  }

];